import { DatePipe } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { AuthenticationService } from 'src/app/service/auth.service';

interface ChatMessage {
  author: string;
  text: string;
  isMine: boolean;
  dateTime?: string
}

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent extends DynamicItem implements OnInit, AfterViewInit {
  messages: ChatMessage[] = [];
  newMessage: string = '';
  @ViewChild('messagesList') messagesListRef: ElementRef<HTMLUListElement>;

  constructor(private authService: AuthenticationService) {
    super()
  }

  get messagesAttr(): AttributeModel {
    let foundAttr = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "items");

    if(!foundAttr) {
      foundAttr = {
        key: "Messages",
        type: "Items",
        attributes: [],
        options: []
      };
      this.attribute.attributes.push(foundAttr);
    }

    return foundAttr;
  }

  ngOnInit() {
    this.messagesAttr.attributes.forEach(messageItem => {
      const fromAttr = messageItem.attributes
        .find(attr => attr.key.toLowerCase() == "from");

      let nameAttr: AttributeModel;

      if(fromAttr) {
        nameAttr = fromAttr.attributes
          .find(attr => attr.key.toLowerCase() == "name");
      } else {
        nameAttr = {
          key: "Name",
          value: "Anonymous",
          type: "Text"
        }
      }

      const messageTextAttr = messageItem.attributes
        .find(attr => attr.key.toLowerCase() == "messagetext");
      const dateAttr = messageItem.attributes
        .find(attr => attr.key.toLowerCase() == "date");

      const currentUser = (this.authService.getUser()?.userName || "").toLowerCase();
      const fromValue = fromAttr && fromAttr.value ? String(fromAttr.value).toLowerCase() : null;
      const messageIsMine = fromValue ? currentUser === fromValue : true;
      const authorName = messageIsMine ? "Você" : (nameAttr && nameAttr.value ? nameAttr.value : "Anonymous");

      this.messages.push({
        author: authorName,
        isMine: messageIsMine,
        text: messageTextAttr ? messageTextAttr.value : "",
        dateTime: dateAttr ? dateAttr.value : ""
      });
    })
    this.scrollToBottom();
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      const message: ChatMessage = {
        author: 'Você',
        text: this.newMessage,
        isMine: true
      };
      this.messages.push(message);

      this.messagesAttr.attributes
        .filter(attr => attr.key.toLowerCase() == "message")
        .forEach(attr => attr.key = "Temp message");

      this.messagesAttr.attributes.push({
        key: `Message-${this.generateGuid()}`,
        type: "Item",
        attributes: [
          {
            key: "MessageText",
            value: this.newMessage,
            type: "Text",
            attributes: [],
            options: []
          }
        ],
        options: []
      });

      this.newMessage = '';

      let events: DynamicEvent[] = [];
      events.push({ name: "autosave" });

      this.emitEvents(events);

      // aguarda a renderização da nova message e faz o scroll
      setTimeout(() => this.scrollToBottom());
    }
  }

  private generateGuid(): string {
    const globalCrypto = (window && window.crypto) ? window.crypto : undefined;
    if (globalCrypto && typeof (globalCrypto as any).randomUUID === 'function') {
      return (globalCrypto as any).randomUUID();
    }
    // Fallback UUID v4 generator
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  formatDate(datetime: string): string {
    if(!datetime) { return ''; }
    const messageDate = new Date(datetime);
    const currentDate = new Date();
    
    if (messageDate.setHours(0, 0, 0, 0) === currentDate.setHours(0, 0, 0, 0)) {
      return new DatePipe('pt-BR').transform(datetime, 'HH:mm');
    } else {
      return new DatePipe('pt-BR').transform(datetime, 'dd/MM/yyyy HH:mm');
    }
  }

  private scrollToBottom(): void {
    if (!this.messagesListRef) { return; }
    try {
      const el = this.messagesListRef.nativeElement;
      el.scrollTop = el.scrollHeight;
    } catch {}
  }
}